import { render } from "./OvaReport.vue?vue&type=template&id=04e07b0e&scoped=true"
import script from "./OvaReport.vue?vue&type=script&lang=js"
export * from "./OvaReport.vue?vue&type=script&lang=js"

import "./OvaReport.vue?vue&type=style&index=0&id=04e07b0e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04e07b0e"]])

export default __exports__